import "./styles.css";
import {
  Book,
  ChevronRight,
  CodeSlash,
  FilePerson,
} from "react-bootstrap-icons";
import LandingHero from "./components/LandingHero";
import About from "./components/About";
import Experience from "./components/Experience/Experience";

function App() {
  return (
    <>
      <nav className="navbar">
        <ul className="navbar-nav">
          <li className="logo">
            <a href="#landing" className="nav-link">
              <span className="link-text">Ferdz Duterte</span>
              <ChevronRight />
            </a>
          </li>
          <li className="nav-item">
            <a href="#about" className="nav-link">
              <FilePerson />

              <span className="link-text">About</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#skills" className="nav-link">
              <CodeSlash />
              <span className="link-text">Skills</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#experience" className="nav-link">
              <Book />
              <span className="link-text">Experience</span>
            </a>
          </li>
        </ul>
      </nav>
      <main>
        <div className="container">
          <LandingHero />
          <About />
          <div className="section" id="skills">
            <div>
              <div className="section-header">Programming Languages</div>
              <div className="section-text">
                <ul className="section-list">
                  <li>Javascript</li>
                  <li>Typescript</li>
                  <li>Python</li>
                  <li>PHP</li>
                  <li>Java</li>
                  <li>C++</li>
                  <li>C#</li>
                  <li>HTML</li>
                  <li>CSS</li>
                  <li>SQL</li>
                  <li>SCSS</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="section">
            <div>
              <div className="section-header">Libraries and Frameworks</div>
              <div className="section-text">
                <ul className="section-list">
                  <li>React</li>
                  <li>Node</li>
                  <li>MySQL</li>
                  <li>Django</li>
                  <li>Flask</li>
                  <li>FastAPI</li>
                  <li>Graphql</li>
                  <li>Jquery</li>
                  <li>Bootstrap</li>
                  <li>Linux</li>
                  <li>Apache</li>
                  <li>Apollo</li>
                  <li>Git</li>
                  <li>Arduino</li>
                  <li>UE5</li>
                </ul>
              </div>
            </div>
          </div>
          <Experience />
        </div>
      </main>
    </>
  );
}

export default App;
